namespace RioERP.Orders {
    export interface OrderFranchiseeShareCalculationForm {
        OrderId: Serenity.LookupEditor;
        OrderProductsId: Serenity.LookupEditor;
        FranchiseeId: Serenity.LookupEditor;
        SharePercentage: Serenity.DecimalEditor;
        OrderProdutcsGrossAmount: Serenity.DecimalEditor;
        ShareAmount: Serenity.DecimalEditor;
        Quantity: Serenity.IntegerEditor;
        SettelmentId: Serenity.IntegerEditor;
        ESettelementStatus: Serenity.EnumEditor;
        TotalShare: Serenity.DecimalEditor;
    }

    export class OrderFranchiseeShareCalculationForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderFranchiseeShareCalculation';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderFranchiseeShareCalculationForm.init)  {
                OrderFranchiseeShareCalculationForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.EnumEditor;

                Q.initFormType(OrderFranchiseeShareCalculationForm, [
                    'OrderId', w0,
                    'OrderProductsId', w0,
                    'FranchiseeId', w0,
                    'SharePercentage', w1,
                    'OrderProdutcsGrossAmount', w1,
                    'ShareAmount', w1,
                    'Quantity', w2,
                    'SettelmentId', w2,
                    'ESettelementStatus', w3,
                    'TotalShare', w1
                ]);
            }
        }
    }
}
